import { render, staticRenderFns } from "./packing.vue?vue&type=template&id=10fc4834&scoped=true"
import script from "./packing.vue?vue&type=script&lang=js"
export * from "./packing.vue?vue&type=script&lang=js"
import style0 from "./packing.vue?vue&type=style&index=0&id=10fc4834&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc4834",
  null
  
)

export default component.exports